/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 17:55:23
 * @Explain: 区域
 */
export default {
  'COMMON.COUNTRY.all': '所有区域',
  'COMMON.COUNTRY.unknown': '未知区域',
  'COMMON.COUNTRY.100': '保加利亚',
  'COMMON.COUNTRY.104': '缅甸',
  'COMMON.COUNTRY.108': '布隆迪',
  'COMMON.COUNTRY.112': '白俄罗斯',
  'COMMON.COUNTRY.116': '柬埔寨',
  'COMMON.COUNTRY.120': '喀麦隆',
  'COMMON.COUNTRY.124': '加拿大',
  'COMMON.COUNTRY.132': '佛得角',
  'COMMON.COUNTRY.136': '开曼群岛',
  'COMMON.COUNTRY.140': '中非',
  'COMMON.COUNTRY.144': '斯里兰卡',
  'COMMON.COUNTRY.148': '乍得',
  'COMMON.COUNTRY.152': '智利',
  'COMMON.COUNTRY.156': '中国',
  'COMMON.COUNTRY.158': '台湾',
  'COMMON.COUNTRY.162': '圣诞岛',
  'COMMON.COUNTRY.166': '科科斯(基林)群岛',
  'COMMON.COUNTRY.170': '哥伦比亚',
  'COMMON.COUNTRY.174': '科摩罗',
  'COMMON.COUNTRY.175': '马约特',
  'COMMON.COUNTRY.178': '刚果共和国',
  'COMMON.COUNTRY.180': '刚果 (刚果民主共和国)',
  'COMMON.COUNTRY.184': '库克群岛',
  'COMMON.COUNTRY.188': '哥斯达黎加',
  'COMMON.COUNTRY.191': '克罗地亚',
  'COMMON.COUNTRY.192': '古巴',
  'COMMON.COUNTRY.196': '塞浦路斯',
  'COMMON.COUNTRY.203': '捷克',
  'COMMON.COUNTRY.204': '贝宁',
  'COMMON.COUNTRY.208': '丹麦',
  'COMMON.COUNTRY.212': '多米尼克',
  'COMMON.COUNTRY.214': '多米尼加',
  'COMMON.COUNTRY.218': '厄瓜多尔',
  'COMMON.COUNTRY.222': '萨尔瓦多',
  'COMMON.COUNTRY.226': '赤道几内亚',
  'COMMON.COUNTRY.231': '埃塞俄比亚',
  'COMMON.COUNTRY.232': '厄立特里亚',
  'COMMON.COUNTRY.233': '爱沙尼亚',
  'COMMON.COUNTRY.234': '法罗群岛',
  'COMMON.COUNTRY.238': '福克兰群岛(马尔维纳斯)',
  'COMMON.COUNTRY.239': '南乔治亚和南桑威奇群岛',
  'COMMON.COUNTRY.242': '斐济',
  'COMMON.COUNTRY.246': '芬兰',
  'COMMON.COUNTRY.248': '奥兰群岛',
  'COMMON.COUNTRY.250': '法国',
  'COMMON.COUNTRY.254': '法属圭亚那',
  'COMMON.COUNTRY.258': '法属波利尼西亚',
  'COMMON.COUNTRY.260': '法国南部领地',
  'COMMON.COUNTRY.262': '吉布提',
  'COMMON.COUNTRY.266': '加蓬',
  'COMMON.COUNTRY.268': '格鲁吉亚',
  'COMMON.COUNTRY.270': '冈比亚',
  'COMMON.COUNTRY.275': '巴勒斯坦',
  'COMMON.COUNTRY.276': '德国',
  'COMMON.COUNTRY.288': '加纳',
  'COMMON.COUNTRY.292': '直布罗陀',
  'COMMON.COUNTRY.296': '基里巴斯',
  'COMMON.COUNTRY.300': '希腊',
  'COMMON.COUNTRY.304': '格陵兰',
  'COMMON.COUNTRY.308': '格林纳达',
  'COMMON.COUNTRY.312': '瓜德罗普',
  'COMMON.COUNTRY.316': '关岛',
  'COMMON.COUNTRY.320': '危地马拉',
  'COMMON.COUNTRY.324': '几内亚',
  'COMMON.COUNTRY.328': '圭亚那',
  'COMMON.COUNTRY.332': '海地',
  'COMMON.COUNTRY.334': '赫德岛和麦克唐纳群岛',
  'COMMON.COUNTRY.336': '梵蒂冈',
  'COMMON.COUNTRY.340': '洪都拉斯',
  'COMMON.COUNTRY.344': '香港',
  'COMMON.COUNTRY.348': '匈牙利',
  'COMMON.COUNTRY.352': '冰岛',
  'COMMON.COUNTRY.356': '印度',
  'COMMON.COUNTRY.360': '印尼',
  'COMMON.COUNTRY.364': '伊朗',
  'COMMON.COUNTRY.368': '伊拉克',
  'COMMON.COUNTRY.372': '爱尔兰',
  'COMMON.COUNTRY.376': '以色列',
  'COMMON.COUNTRY.380': '意大利',
  'COMMON.COUNTRY.384': '科特迪瓦',
  'COMMON.COUNTRY.388': '牙买加',
  'COMMON.COUNTRY.392': '日本',
  'COMMON.COUNTRY.398': '哈萨克斯坦',
  'COMMON.COUNTRY.400': '约旦',
  'COMMON.COUNTRY.404': '肯尼亚',
  'COMMON.COUNTRY.408': '朝鲜',
  'COMMON.COUNTRY.410': '大韩(民国)',
  'COMMON.COUNTRY.414': '科威特',
  'COMMON.COUNTRY.417': '吉尔吉斯斯坦',
  'COMMON.COUNTRY.418': '老挝',
  'COMMON.COUNTRY.422': '黎巴嫩',
  'COMMON.COUNTRY.426': '莱索托',
  'COMMON.COUNTRY.428': '拉脱维亚',
  'COMMON.COUNTRY.430': '利比里亚',
  'COMMON.COUNTRY.434': '利比亚',
  'COMMON.COUNTRY.438': '列支敦士登',
  'COMMON.COUNTRY.440': '立陶宛',
  'COMMON.COUNTRY.442': '卢森堡',
  'COMMON.COUNTRY.446': '澳门',
  'COMMON.COUNTRY.450': '马达加斯加',
  'COMMON.COUNTRY.454': '马拉维',
  'COMMON.COUNTRY.458': '马来西亚',
  'COMMON.COUNTRY.462': '马尔代夫',
  'COMMON.COUNTRY.466': '马里',
  'COMMON.COUNTRY.470': '马耳他',
  'COMMON.COUNTRY.474': '马提尼克',
  'COMMON.COUNTRY.478': '毛里塔尼亚',
  'COMMON.COUNTRY.480': '毛里求斯',
  'COMMON.COUNTRY.484': '墨西哥',
  'COMMON.COUNTRY.492': '摩纳哥',
  'COMMON.COUNTRY.496': '蒙古',
  'COMMON.COUNTRY.498': '摩尔多瓦',
  'COMMON.COUNTRY.499': '黑山',
  'COMMON.COUNTRY.500': '蒙特塞拉特',
  'COMMON.COUNTRY.504': '摩洛哥',
  'COMMON.COUNTRY.508': '莫桑比克',
  'COMMON.COUNTRY.512': '阿曼',
  'COMMON.COUNTRY.516': '纳米比亚',
  'COMMON.COUNTRY.520': '瑙鲁',
  'COMMON.COUNTRY.524': '尼泊尔',
  'COMMON.COUNTRY.528': '荷兰',
  'COMMON.COUNTRY.531': '库拉索',
  'COMMON.COUNTRY.533': '阿鲁巴',
  'COMMON.COUNTRY.534': '荷属圣马丁',
  'COMMON.COUNTRY.535': '博内尔',
  'COMMON.COUNTRY.540': '新喀里多尼亚',
  'COMMON.COUNTRY.548': '瓦努阿图',
  'COMMON.COUNTRY.554': '新西兰',
  'COMMON.COUNTRY.558': '尼加拉瓜',
  'COMMON.COUNTRY.562': '尼日尔',
  'COMMON.COUNTRY.566': '尼日利亚',
  'COMMON.COUNTRY.570': '纽埃',
  'COMMON.COUNTRY.574': '诺福克岛',
  'COMMON.COUNTRY.578': '挪威',
  'COMMON.COUNTRY.580': '北马里亚纳群岛',
  'COMMON.COUNTRY.581': '美国本土外小岛屿',
  'COMMON.COUNTRY.583': '密克罗尼西亚(联邦)',
  'COMMON.COUNTRY.584': '马绍尔群岛',
  'COMMON.COUNTRY.585': '帕劳',
  'COMMON.COUNTRY.586': '巴基斯坦',
  'COMMON.COUNTRY.591': '巴拿马',
  'COMMON.COUNTRY.598': '巴布亚新几內亚',
  'COMMON.COUNTRY.600': '巴拉圭',
  'COMMON.COUNTRY.604': '秘鲁',
  'COMMON.COUNTRY.608': '菲律宾',
  'COMMON.COUNTRY.612': '皮特凯恩群岛',
  'COMMON.COUNTRY.616': '波兰',
  'COMMON.COUNTRY.620': '葡萄牙',
  'COMMON.COUNTRY.624': '几内亚比绍',
  'COMMON.COUNTRY.626': '东帝汶',
  'COMMON.COUNTRY.630': '波多黎各',
  'COMMON.COUNTRY.634': '卡塔尔',
  'COMMON.COUNTRY.638': '留尼汪',
  'COMMON.COUNTRY.642': '罗马尼亚',
  'COMMON.COUNTRY.643': '俄罗斯',
  'COMMON.COUNTRY.646': '卢旺达',
  'COMMON.COUNTRY.652': '圣巴泰勒米',
  'COMMON.COUNTRY.654': '圣卢西亚',
  'COMMON.COUNTRY.659': '圣基茨和尼维斯',
  'COMMON.COUNTRY.660': '安圭拉',
  'COMMON.COUNTRY.662': '圣卢西亚',
  'COMMON.COUNTRY.663': '法属圣马丁',
  'COMMON.COUNTRY.666': '圣皮埃尔和密克隆',
  'COMMON.COUNTRY.670': '圣文森特和格林纳丁斯',
  'COMMON.COUNTRY.674': '圣马力诺',
  'COMMON.COUNTRY.678': '圣多美和普林西比',
  'COMMON.COUNTRY.682': '沙特阿拉伯',
  'COMMON.COUNTRY.686': '塞内加尔',
  'COMMON.COUNTRY.688': '塞尔维亚',
  'COMMON.COUNTRY.690': '塞舌尔',
  'COMMON.COUNTRY.694': '塞拉利昂',
  'COMMON.COUNTRY.702': '新加坡',
  'COMMON.COUNTRY.703': '斯洛伐克',
  'COMMON.COUNTRY.704': '越南',
  'COMMON.COUNTRY.705': '斯洛文尼亚',
  'COMMON.COUNTRY.706': '索马里',
  'COMMON.COUNTRY.710': '南非',
  'COMMON.COUNTRY.716': '津巴布韦',
  'COMMON.COUNTRY.724': '西班牙',
  'COMMON.COUNTRY.728': '南苏丹',
  'COMMON.COUNTRY.729': '苏丹',
  'COMMON.COUNTRY.732': '西撒哈拉',
  'COMMON.COUNTRY.740': '苏里南',
  'COMMON.COUNTRY.744': '斯瓦尔巴和扬马延岛',
  'COMMON.COUNTRY.748': '斯威士兰',
  'COMMON.COUNTRY.752': '瑞典',
  'COMMON.COUNTRY.756': '瑞士',
  'COMMON.COUNTRY.760': '叙利亚',
  'COMMON.COUNTRY.762': '塔吉克斯坦',
  'COMMON.COUNTRY.764': '泰国',
  'COMMON.COUNTRY.768': '多哥',
  'COMMON.COUNTRY.772': '托克劳',
  'COMMON.COUNTRY.776': '汤加',
  'COMMON.COUNTRY.780': '特立尼达和多巴哥',
  'COMMON.COUNTRY.784': '阿联酋',
  'COMMON.COUNTRY.788': '突尼斯',
  'COMMON.COUNTRY.792': '土耳其',
  'COMMON.COUNTRY.795': '土库曼斯坦',
  'COMMON.COUNTRY.796': '特克斯和凯科斯群岛',
  'COMMON.COUNTRY.798': '图瓦卢',
  'COMMON.COUNTRY.800': '乌干达',
  'COMMON.COUNTRY.804': '乌克兰',
  'COMMON.COUNTRY.807': '北马其顿',
  'COMMON.COUNTRY.818': '埃及',
  'COMMON.COUNTRY.826': '英国',
  'COMMON.COUNTRY.831': '根西',
  'COMMON.COUNTRY.832': '泽西',
  'COMMON.COUNTRY.833': '马恩岛',
  'COMMON.COUNTRY.834': '坦桑尼亚',
  'COMMON.COUNTRY.840': '美国',
  'COMMON.COUNTRY.850': '美属维尔京群岛',
  'COMMON.COUNTRY.854': '布基纳法索',
  'COMMON.COUNTRY.858': '乌拉圭',
  'COMMON.COUNTRY.860': '乌兹别克斯坦',
  'COMMON.COUNTRY.862': '委内瑞拉',
  'COMMON.COUNTRY.876': '瓦利斯和富图纳',
  'COMMON.COUNTRY.882': '萨摩亚',
  'COMMON.COUNTRY.887': '也门',
  'COMMON.COUNTRY.894': '赞比亚',
  'COMMON.COUNTRY.998': '欧盟',
  'COMMON.COUNTRY.999': '未知区域',
  'COMMON.COUNTRY.004': '阿富汗',
  'COMMON.COUNTRY.008': '阿尔巴尼亚',
  'COMMON.COUNTRY.012': '阿尔及利亚',
  'COMMON.COUNTRY.016': '美属萨摩亚',
  'COMMON.COUNTRY.020': '安道尔',
  'COMMON.COUNTRY.024': '安哥拉',
  'COMMON.COUNTRY.010': '南极洲',
  'COMMON.COUNTRY.028': '安提瓜和巴布达',
  'COMMON.COUNTRY.032': '阿根廷',
  'COMMON.COUNTRY.051': '亚美尼亚',
  'COMMON.COUNTRY.036': '澳大利亚',
  'COMMON.COUNTRY.040': '奥地利',
  'COMMON.COUNTRY.031': '阿塞拜疆',
  'COMMON.COUNTRY.044': '巴哈马',
  'COMMON.COUNTRY.048': '巴林',
  'COMMON.COUNTRY.050': '孟加拉国',
  'COMMON.COUNTRY.052': '巴巴多斯',
  'COMMON.COUNTRY.056': '比利时',
  'COMMON.COUNTRY.084': '伯利兹',
  'COMMON.COUNTRY.060': '百慕大',
  'COMMON.COUNTRY.064': '不丹',
  'COMMON.COUNTRY.068': '玻利维亚',
  'COMMON.COUNTRY.070': '波斯尼亚和黑塞哥维那',
  'COMMON.COUNTRY.072': '博茨瓦那',
  'COMMON.COUNTRY.074': '布韦岛',
  'COMMON.COUNTRY.076': '巴西',
  'COMMON.COUNTRY.086': '英属印度洋领地',
  'COMMON.COUNTRY.096': '文莱',
  'COMMON.COUNTRY.090': '所罗门群岛',
  'COMMON.COUNTRY.092': '英属维尔京群岛',
};
